import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-filesystem-browser',
    templateUrl: './filesystem-browser.component.html',
    styleUrls: ['./filesystem-browser.component.scss'],
    standalone: false
})
export class FilesystemBrowserComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
